import Vue from 'vue'
import App from './App.vue'
import Vant from 'vant'
import 'vant/lib/index.css'
import './common/font.css'
import './assets/css/_normal.scss'
import router from '@/router/index'
import query from '@/utils/query'
// import VConsole from 'vconsole'
// new VConsole()
Vue.use(Vant)
Vue.prototype.$query = query

new Vue({
  router,
  render: (h) => h(App),
}).$mount('#app')
